import { apiAxios } from '@/api'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { fetchIfNeededWrapper } from '@/reducers/fetch'
import { CubkStatusResponse } from './cubkProgress.types'

interface CubkProgressState {
  data: CubkStatusResponse | null
}

const initialState: CubkProgressState = {
  data: null,
}

const cubkProgressSlice = createSlice({
  name: 'cubkProgress',
  initialState,
  reducers: {
    receiveCubkProgress: (state, action: PayloadAction<CubkStatusResponse>) => {
      state.data = action.payload
    },
  },
})

export default cubkProgressSlice.reducer

const { receiveCubkProgress } = cubkProgressSlice.actions

export const FETCH_CUBK_PROGRESS_KEY = 'FETCH_CUBK_PROGRESS_KEY'

export const fetchCubkProgress = (params: { forceFetch?: boolean } = {}) => {
  const { forceFetch } = params

  return fetchIfNeededWrapper({
    fetchKey: FETCH_CUBK_PROGRESS_KEY,
    alwaysFetch: Boolean(forceFetch),
    defaultErrorMessage: 'Error fetching catch-up bookkeeping progress',
    fetchFunction: async (dispatch) => {
      const json = await apiAxios.get<CubkStatusResponse>(
        '/finances/api/v2/catch_up_bookkeeping_status/progress'
      )

      dispatch(receiveCubkProgress(json.data))
      return json.data
    },
  })
}
